module.exports = __webpack_public_path__ + "img/3cd1b62.jpg";